function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m47.785156 47.785156h314.027344v314.027344h-314.027344zm0 0",
  fill: "#94c1ff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#0e65e5"
}, React.createElement("path", {
  d: "m361.8125 368.640625h-314.027344c-3.773437 0-6.824218-3.054687-6.824218-6.828125v-314.027344c0-3.773437 3.050781-6.824218 6.824218-6.824218h314.027344c3.773438 0 6.828125 3.050781 6.828125 6.824218v314.027344c0 3.773438-3.054687 6.828125-6.828125 6.828125zm-307.199219-13.652344h300.375v-300.375h-300.375zm0 0"
}), React.createElement("path", {
  d: "m150.1875 150.1875h109.226562v109.226562h-109.226562zm0 0",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "m259.414062 266.238281h-109.226562c-3.773438 0-6.828125-3.050781-6.828125-6.824219v-109.226562c0-3.773438 3.054687-6.828125 6.828125-6.828125h109.226562c3.773438 0 6.824219 3.054687 6.824219 6.828125v109.226562c0 3.773438-3.050781 6.824219-6.824219 6.824219zm-102.402343-13.652343h95.574219v-95.574219h-95.574219zm0 0"
}), React.createElement("path", {
  d: "m47.785156 34.132812c-3.773437 0-6.824218-3.050781-6.824218-6.824218v-20.480469c0-3.773437 3.050781-6.828125 6.824218-6.828125 3.773438 0 6.828125 3.054688 6.828125 6.828125v20.480469c0 3.773437-3.054687 6.824218-6.828125 6.824218zm0 0"
}), React.createElement("path", {
  d: "m27.308594 54.613281h-20.480469c-3.773437 0-6.828125-3.054687-6.828125-6.828125 0-3.773437 3.054688-6.824218 6.828125-6.824218h20.480469c3.773437 0 6.824218 3.050781 6.824218 6.824218 0 3.773438-3.050781 6.828125-6.824218 6.828125zm0 0"
}), React.createElement("path", {
  d: "m27.308594 368.640625h-20.480469c-3.773437 0-6.828125-3.054687-6.828125-6.828125s3.054688-6.824219 6.828125-6.824219h20.480469c3.773437 0 6.824218 3.050781 6.824218 6.824219s-3.050781 6.828125-6.824218 6.828125zm0 0"
}), React.createElement("path", {
  d: "m47.785156 409.601562c-3.773437 0-6.824218-3.054687-6.824218-6.828124v-20.480469c0-3.773438 3.050781-6.828125 6.824218-6.828125 3.773438 0 6.828125 3.054687 6.828125 6.828125v20.480469c0 3.773437-3.054687 6.828124-6.828125 6.828124zm0 0"
}), React.createElement("path", {
  d: "m361.8125 409.601562c-3.773438 0-6.824219-3.054687-6.824219-6.828124v-20.480469c0-3.773438 3.050781-6.828125 6.824219-6.828125s6.828125 3.054687 6.828125 6.828125v20.480469c0 3.773437-3.054687 6.828124-6.828125 6.828124zm0 0"
}), React.createElement("path", {
  d: "m402.773438 368.640625h-20.480469c-3.773438 0-6.828125-3.054687-6.828125-6.828125s3.054687-6.824219 6.828125-6.824219h20.480469c3.773437 0 6.828124 3.050781 6.828124 6.824219s-3.054687 6.828125-6.828124 6.828125zm0 0"
}), React.createElement("path", {
  d: "m402.773438 54.613281h-20.480469c-3.773438 0-6.828125-3.054687-6.828125-6.828125 0-3.773437 3.054687-6.824218 6.828125-6.824218h20.480469c3.773437 0 6.828124 3.050781 6.828124 6.824218 0 3.773438-3.054687 6.828125-6.828124 6.828125zm0 0"
}), React.createElement("path", {
  d: "m361.8125 34.132812c-3.773438 0-6.824219-3.050781-6.824219-6.824218v-20.480469c0-3.773437 3.050781-6.828125 6.824219-6.828125s6.828125 3.054688 6.828125 6.828125v20.480469c0 3.773437-3.054687 6.824218-6.828125 6.824218zm0 0"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m314.027344 320.851562c-3.773438 0-6.828125-3.050781-6.828125-6.824218v-27.308594c0-3.773438 3.054687-6.824219 6.828125-6.824219 3.773437 0 6.824218 3.050781 6.824218 6.824219v27.308594c0 3.773437-3.050781 6.824218-6.824218 6.824218zm0 0",
  fill: "#fff"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m327.679688 307.199219h-27.304688c-3.773438 0-6.828125-3.050781-6.828125-6.824219s3.054687-6.828125 6.828125-6.828125h27.304688c3.773437 0 6.828124 3.054687 6.828124 6.828125s-3.054687 6.824219-6.828124 6.824219zm0 0",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m68.265625 102.398438c-3.773437 0-6.824219-3.050782-6.824219-6.824219v-27.308594c0-3.773437 3.050782-6.824219 6.824219-6.824219h27.308594c3.773437 0 6.824219 3.050782 6.824219 6.824219s-3.050782 6.828125-6.824219 6.828125h-20.480469v20.480469c0 3.773437-3.054688 6.824219-6.828125 6.824219zm0 0",
  fill: "#fff"
});

var SvgSelectionBlue = function SvgSelectionBlue(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "409.6pt",
    viewBox: "0 0 409.6 409.6",
    width: "409.6pt",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSelectionBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/selection-blue.7e1c5063.svg";
export { ForwardRef as ReactComponent };